import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import * as _ from 'lodash';
import {catchError} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class GlobalValidationService extends BaseHttpService {

    private rootUrl: string = 'global-page/validation';
    validations = {};
    validationsSubject = new BehaviorSubject(false);

    fetch(brandId: string): Observable<any> {
      return new Observable(observer => {
        this.http.get(`${Config.API}/${this.rootUrl}/${brandId}`)
          .pipe(catchError(this.handleError.bind(this)))
          .subscribe(res => {
            this.validations = res;
            this.validationsSubject.next(res);
            observer.next(res);
            return observer.complete();
          });
      });
    }
}
